import React from 'react';
import { Link } from 'react-router-dom';
import IconoPizza from './../img/pizza_icon.png';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import './styles/Header.css'


const Header = () => {


    return (
        <header className='container mt-5'>
            <div className='row'>
                <div className='col d-flex justify-content-between'>
                    <Link to='/' className='d-flex'>
                        <img src={IconoPizza} alt='piza-icon' className='icon' />
                        <h1>Flama Pizzas </h1>
                    </Link>
                    <div className='d-flex align-items-center'>

                        <Link to='/login' className='login__icon'>

                            <svg xmlns="http://www.w3.org/2000/svg" width='20' height="20" fill="currentColor" className="bi bi-box-arrow-in-right" viewBox="0 0 16 16" style={{color: 'white'}}>
                                <path fillRule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z" />
                                <path fillRule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" />
                            </svg>
                            
                        </Link>  

                    </div>
                </div>
            </div>
            <hr/>
        </header>
    );
}

export default Header;